<template>
    <set-google-json-credentials-dialog
        :value="value"
        @input="$emit('input', $event)"
        :loading="$wait.is('creatingGoogleAccount')"
        :edit="edit"
        :disabled="{ ...(disabled || {}), Name: true, UseTenantCurrencies: true }"
    >
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #actions="{ form, formId, isValid, clear, close }">
            <put-credential-button
                type="GoogleJsonUsageCredential"
                :value="{ ...edit, ...form }"
                :clear="clear"
                :valid="isValid"
                :form="formId"
                v-wait-while="'creatingGoogleAccount'"
                @http2xx="acceptSubmit($event, close)"
            ></put-credential-button>
        </template>
    </set-google-json-credentials-dialog>
</template>

<script>
import SetGoogleJsonCredentialsDialog from '@/components/Settings.CloudAccounts/Google/SetGoogleJsonCredentialsDialog.vue';
import PutCredentialButton from '@/components/Settings.CloudAccounts/PutCredentialButton.vue';
export default {
    components: { SetGoogleJsonCredentialsDialog, PutCredentialButton },
    props: {
        value: Boolean,
        edit: Object,
        disabled: Object,
    },
    methods: {
        async acceptSubmit($event, close) {
            await close();
            this.$emit('http2xx', $event);
        },
    },
};
</script>